import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  getCurrentSession,
  loginWithPassword,
  refreshSession,
} from "./utils/userManager";

const LoginWindow = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const PinPad = styled.div`
  background-color: white;
  height: auto;
  width: 40vw;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.2vh;
  padding: 2vh;
`;
const StyledImg = styled.img`
  width: 5vh;
  height: 5vh;
  margin: 2vh 0.5vh 0.5vh 0.5vh;
  align-self: center;
`;
const Button = styled.button`
  width: 100%;
  height: 6vh;
  background-color: white;
  font-size: 2.4vh;
  color: #4a6283;
  padding: 1vh;
  border: 1px solid #4a6283;
`;

const Input = styled.input`
  width: 100%;
  border: 1px solid #4a6283;
  font-size: 2.2vh;
  height: 6vh;
  color: black;
  padding: 1vh;
`;

const Login = () => {
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const session = getCurrentSession();
    if (session) {
      refreshSession().then((fresh) => {
        if (fresh) {
          navigate("/edabstatus");
        }
      });
    }
  }, [navigate]);

  async function handleLogin(e) {
    e.preventDefault();
    setErrorMessage("");
    try {
      await loginWithPassword(password);
      navigate("/edabstatus");
    } catch (error) {
      setErrorMessage(error.message || "Login failed.");
    }
  }

  return (
    <LoginWindow>
      <PinPad>
        <StyledImg
          src={"https://edab.online/images/EDAB.png"}
          alt="☺"
        />
        <form
          onSubmit={handleLogin}
          style={{ width: "70%", display: "flex", flexDirection: "column", gap: "1vh" }}
        >
          <Input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit">Login</Button>
          {errorMessage && (
            <p style={{ color: "#b42318", fontSize: "1.7vh" }}>{errorMessage}</p>
          )}
        </form>
      </PinPad>
    </LoginWindow>
  );
};

export default Login;
